
(function(d) {
	var config = {
		kitId: 'ota8ijc',
		scriptTimeout: 3000,
		async: true
	},
	h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
})(document);

(function ($) {
	$(function () {
		$('a[href^="#"]').on("click", function (e) {
			e.preventDefault();

			let point	=	$(this).attr("href");
			
			if(point == "#") {
				$("html, body").animate({scrollTop: 0});
				return;
			}

			$("html, body").animate({scrollTop: $(point).offset().top});
		});

		$("footer .pagetop").on("click", function (e) {
			e.preventDefault();

			$("html, body").animate({scrollTop: 0});
		});

		$("header .switch").on("click", function () {
			let $target	=	$(this);

			$target.toggleClass("opened");

			if($("header nav").hasClass("lock")) {
				$("header nav").removeClass("lock").hide();
			}
;
			if($target.hasClass("opened")) {
				$("header nav").slideDown();
			}
			else {
				$("header nav").slideUp();
			}
		});

		$("header .menus .menu > li > span").on("click", function () {
			let $target	=	$(this);

			$target.toggleClass("opened");

			if($target.hasClass("opened")) {
				$target.next(".submenu").slideDown();
			}
			else {
				$target.next(".submenu").slideUp();
			}
		})
	});
})(jQuery);